"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.poolKeys2JsonInfo = exports.jsonInfo2PoolKeys = void 0;
const web3_js_1 = require("@solana/web3.js");
const logger_1 = require("./logger");
const pubkey_1 = require("./pubkey");
const logger = new logger_1.Logger("Common.CovertJson");
function jsonInfo2PoolKeys(jsonInfo) {
    // @ts-expect-error no need type for inner code
    return Object.entries(jsonInfo).reduce((result, [key, value]) => {
        if (typeof value === "string") {
            result[key] = (0, pubkey_1.validateAndParsePublicKey)(value);
        }
        else if (value instanceof Array) {
            result[key] = value.map((k) => (0, pubkey_1.validateAndParsePublicKey)(k));
        }
        else if (typeof value === "number") {
            result[key] = value;
        }
        else {
            return logger.throwArgumentError("invalid value", key, value);
        }
        return result;
    }, {});
}
exports.jsonInfo2PoolKeys = jsonInfo2PoolKeys;
function poolKeys2JsonInfo(jsonInfo) {
    // @ts-expect-error no need type for inner code
    return Object.entries(jsonInfo).reduce((result, [key, value]) => {
        if (value instanceof web3_js_1.PublicKey) {
            result[key] = value.toBase58();
        }
        else if (value instanceof Array) {
            result[key] = value.map((k) => k.toBase58());
        }
        else if (typeof value === "number") {
            result[key] = value;
        }
        else {
            return logger.throwArgumentError("invalid value", key, value);
        }
        return result;
    }, {});
}
exports.poolKeys2JsonInfo = poolKeys2JsonInfo;
//# sourceMappingURL=convert-json.js.map